import React, { Suspense } from 'react';
import { createBrowserRouter, RouteObject } from 'react-router';

import { AppLayout } from '@/components/layout/AppLayout.comp.tsx';
import { PageLoading } from '@/components/layout/routes/PageLoading.comp.tsx';
import { assertRouteAccess, contextMiddleware } from '@/middleware/contextMiddleware.middleware.ts';
import { ROUTES } from '@/models/route/routes.ts';
import { NotFound } from '@/views/generalError/notFound/NotFound.comp.tsx';

const suspenseElement = (View: React.FC) => (
  <Suspense fallback={<PageLoading />}>
    <View />
  </Suspense>
);

const routeObjects: RouteObject[] = ROUTES.map(({ component: Component, handle, load, path }) => {
  const middleware = [contextMiddleware(path)];

  if (!load) {
    return { element: suspenseElement(Component as React.FC), handle, middleware, path };
  }

  return {
    lazy: async () => {
      // ponytail: route.lazy fires eagerly (before middleware runs), so the check is
      // repeated here — otherwise an unauthorized user would still download the chunk.
      await assertRouteAccess(path);
      const { default: View } = await load();
      return { Component: () => suspenseElement(View) };
    },
    handle,
    middleware,
    path,
  };
});

export const router = createBrowserRouter([
  {
    children: [...routeObjects, { element: <NotFound />, path: '*' }],
    element: <AppLayout />,
  },
]);
